import React, { useContext } from "react";
import { Switch, Route } from "react-router-dom";

import SuccessRegister from "../pages/SuccessRegister";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import Profile from "../pages/Profile";
import Link from "../pages/Link";
import Appearance from "../pages/Appearance";
import Analytic from "../pages/Analytic";
import NotFound from "../pages/NotFound";

import PrivateRoute from "./PrivateRoute";
import VerifyRoute from "./VerivyRoute";
import RestrictedRoute from "./RestrictedRoute";

import { AuthContext } from "../context/AuthContext";

import ModalAbout from "../components/ModalAbout";
import ModalTerms from "../components/ModalTerms";

export default function MainRoute() {
  const { isLoading } = useContext(AuthContext);

  return (
    <>
      {isLoading ? (
        <p className="darktextColor textTitle text">Loading ... </p>
      ) : (
        <Switch>
          <PrivateRoute component={Dashboard} path="/main/dashboard" exact />
          <PrivateRoute component={Profile} path="/main/profile" exact />
          <PrivateRoute component={Appearance} path="/main/appearance" exact />
          <PrivateRoute component={Link} path="/main/link" exact />
          <PrivateRoute component={Analytic} path="/main/analytic" exact />
          <VerifyRoute
            component={SuccessRegister}
            path="/user/verify-email"
            exact
          />
          <RestrictedRoute component={Login} path="/" exact />

          <Route exact path="/blog/about">
            <ModalAbout />
          </Route>
          <Route exact path="/blog/terms-and-conditions">
            <ModalTerms />
          </Route>
          <Route>
            <NotFound />
          </Route>
        </Switch>
      )}
    </>
  );
}
